module.exports = __webpack_public_path__ + "img/역삼역 미용실.a9225272.png";